import { createFileRoute, Link } from '@tanstack/react-router'
import UserProfile from '@/components/user/userProfile.jsx'
import useStore from '@/hooks/useStore.js'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { mdiStorefrontRemoveOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { Button } from '@/components/ui/button.jsx'
import useView from '@/hooks/useView.js'
import { LoadingIndicator, LoadingIndicatorTitle } from '@/components/ui/loadingIndicator.jsx'
import PostsList from '@/components/post/postsList.jsx'
import UserProfileBackground from '@/components/user/userProfileBackground.jsx'
import ContentMenu from '@/components/contentMenu/contentMenu.jsx'

const StorePage = () => {
  const { routerStore } = useStore()
  const { storeView } = useView()

  useEffect(() => {
    storeView.init().then()

    return () => {
      storeView.reset()
    }
  }, [storeView, routerStore.path])

  if (!storeView.isInitialized)
    return (
      <LoadingIndicator>
        <LoadingIndicatorTitle>Loading...</LoadingIndicatorTitle>
      </LoadingIndicator>
    )

  if (!storeView.exists)
    return (
      <div className="flex grow flex-col items-center justify-center gap-6 p-3">
        <Icon className="max-h-fit w-full max-w-32" path={mdiStorefrontRemoveOutline} size="100%" />

        <h1 className="text-center text-2xl">
          {routerStore.params.handle}
          <span className="block text-xl">does not exist</span>
        </h1>

        <Button asChild>
          <Link to={routerStore.routes.index}>Go Home</Link>
        </Button>
      </div>
    )

  return (
    <>
      <UserProfileBackground user={storeView.user} />

      <div className="animate-in fade-in w-full duration-1000">
        <div className="mx-auto w-full max-w-3xl">
          <UserProfile
            className="animate-in slide-in-from-top-3 duration-1000"
            user={storeView.user}
          />
          <ContentMenu className="mt-6" />
        </div>

        <PostsList className="animate-in slide-in-from-bottom-3 my-6 duration-1000" />
      </div>
    </>
  )
}

export const Route = createFileRoute('/store/$handle')({
  component: observer(StorePage),
})
